import Highway from '@dogstudio/highway'
import TweenMax from 'gsap/TweenMax'
import Loader from '../util/Loader'
import App from '../App';

export default class Panel extends Highway.Transition {
  in({ from, to, done }) {
    from.remove()

    this.getElems()
    this.startSmoothScrool()

    // if (App.isMobile) {
    //   done()
    //   this.hideLoader(to)
    // } else {
      Loader.load(to)
      .then(() => {
        this.hideLoader(to).then(() => done())
        // window.setTimeout(() => {
        //   done()
        // }, 2000)
      })
    // }
  }

  out({ from, done }) {
    this.getElems()
    this.stopSmoothScrool()

    setTimeout(() => {
      this.showLoader(from).then(done)
    }, 0);
  }

  hideLoader() {
    return new Promise((resolve) => {

      if (this.elmLoader) this.elmLoader.classList.remove('show')

      TweenMax.staggerTo(this.panels, 0.5, {
        delay: 0,
        x: '105%',
        ease: Expo.easeInOut
      }, 0.04, this.onCompleteAll)

      window.setTimeout(() => {
        resolve()
      }, 200)
    })
  }

  onCompleteAll() {
    document.body.classList.add('page-ready')
  }

  showLoader() {
    return new Promise((resolve) => {

      TweenMax.set(this.panels, { x: '-100%' })
      document.body.classList.remove('page-ready')

      TweenMax.staggerTo(this.panels, 0.5, {
        x: '0%',
        ease: Expo.easeOut,
        onComplete: () => {
          if (this.elmLoader) this.elmLoader.classList.add('show')
          document.body.classList.remove('page-ready')
          window.scrollTo(0, 0)
        }
      }, 0.04, resolve)
    })
  }

  getElems() {
    if (!this.elmLoader) this.elmLoader = document.querySelector('.loader')
    if (this.elmLoader) this.panels = this.elmLoader.querySelectorAll('.panel')
    if (!this.elmHeader) this.elmHeader = document.querySelector('.header')
    if (!this.elmFooter) this.elmFooter = document.querySelector('.footer')
  }

  startSmoothScrool() {
    if (!App.smoothScroll) return

    if (App.isMobile) {
      window.scrollTo(0, 0)
      App.smoothScroll.update()
      App.smoothScroll.start()
    } else {
      App.smoothScroll.setScroll(0, 0)
      App.smoothScroll.update()
      App.smoothScroll.scroll.scrollbarThumb.style.height = `${window.innerHeight * window.innerHeight / (App.smoothScroll.scroll.instance.limit + window.innerHeight)}px`
      App.smoothScroll.scroll.scrollBarLimit = window.innerHeight - App.smoothScroll.scroll.scrollbarThumb.getBoundingClientRect().height
      App.smoothScroll.scroll.startScrolling()
      App.smoothScroll.start()
    }
  }

  stopSmoothScrool() {
    if (!App.smoothScroll) return

    if (App.isMobile) App.smoothScroll.stop()
    else {
      App.smoothScroll.scroll.stopScrolling()
      App.smoothScroll.stop()
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/transitions/Panel.js